module.exports = __webpack_public_path__ + "static/crafter-servis-1502fd33f683319fb135b4e654fcb1f3.png";